import { html } from "../../"
import type { SYSFormState } from "../forms/actions"
import { SYSBaseElement } from "../sysbaseelement"

export type CellClass = {
  className?: string
  tooltip?: string
}

export class SYSTableValidationSummaryRow extends SYSBaseElement {
  props: any
  row: { formState: SYSFormState; columnsCount: number }
  async init() {
    this.row = this.props()
    await super.init()
  }
  async getUI() {
    return html`
      <td
        colspan="${this.row.columnsCount}"
        class="fd-table__cell ovl-validation-summary"
      >
        <ovl-formvalidationhint .props=${() => this.row.formState}>
        </ovl-formvalidationhint>
      </td>
    `
  }
}
